import request from "@/utils/request";

//1,获取列表
export function getScoreResults(data){
    return request({
        url:'/admin/getScoreResults',
        data:data,
        method:'get'
    })
}
//2,改变作品初赛状态
export function updateWorkStage(data){
    return request({
        url:'/admin/updateWorkStage',
        data:data,
        method:'post'
    })
}
//2,改变作品复赛状态
export function updateWorkFinalStatus(data){
    return request({
        url:'/admin/updateWorkFinalStatus',
        data:data,
        method:'post'
    })
}
//2,导出评分结果
export function exportScoreResults(data){
    return request({
        url:'/admin/exportScoreResults',
        data:data,
        method:'get'
    })
}

//3,上传文件
export function uploadScoreResults(data){
    return request({
        url:'/admin/uploadScoreResults',
        data:data,
        method:'post'
    })
}
